import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Notification",
  "use": "Notification-usage",
  "viewBox": "0 0 20 23",
  "content": "<symbol viewBox=\"0 0 20 23\" id=\"Notification\"><path d=\"M18.332 15h-.42C19.07 15 20 15.932 20 17.083v.418a.831.831 0 0 1-.834.832H.834A.833.833 0 0 1 0 17.501v-.418C0 15.933.934 15 2.087 15h-.42a.834.834 0 0 0 .833-.834v-5c0-4.143 3.358-7.5 7.5-7.5a7.5 7.5 0 0 1 7.5 7.5v5c0 .463.373.834.832.834zM7.083 19.167h5.834a2.917 2.917 0 0 1-5.834 0zm5.834-16.25H7.083a2.917 2.917 0 0 1 5.834 0z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol